export const commonOptions = {

    data() {
        return {
            opts: {
                yesNoOptions: [
                    { value: 'Y', text: 'Yes' },
                    { value: 'N', text: 'No' },
                ],

                yesNoBoolOptions: [
                    { value: true, text: 'Yes' },
                    { value: false, text: 'No' },
                ],

                yesNoUnknownOptions: [
                    { value: 'Y', text: 'Yes' },
                    { value: 'N', text: 'No' },
                    { value: 'U', text: 'Unknown' },
                ],

                stateOptions: [
                    { value:"AK", text:"Alaska" },
                    { value:"AL", text:"Alabama" },
                    { value:"AR", text:"Arkansas" },
                    { value:"AZ", text:"Arizona" },
                    { value:"CA", text:"California" },
                    { value:"CO", text:"Colorado" },
                    { value:"CT", text:"Connecticut" },
                    { value:"DC", text:"District of Columbia" },
                    { value:"DE", text:"Delaware" },
                    { value:"FL", text:"Florida" },
                    { value:"GA", text:"Georgia" },
                    { value:"HI", text:"Hawaii" },
                    { value:"IA", text:"Iowa" },
                    { value:"ID", text:"Idaho" },
                    { value:"IL", text:"Illinois" },
                    { value:"IN", text:"Indiana" },
                    { value:"KS", text:"Kansas" },
                    { value:"KY", text:"Kentucky" },
                    { value:"LA", text:"Louisiana" },
                    { value:"MA", text:"Massachusetts" },
                    { value:"MD", text:"Maryland" },
                    { value:"ME", text:"Maine" },
                    { value:"MI", text:"Michigan" },
                    { value:"MN", text:"Minnesota" },
                    { value:"MO", text:"Missouri" },
                    { value:"MS", text:"Mississippi" },
                    { value:"MT", text:"Montana" },
                    { value:"NC", text:"North Carolina" },
                    { value:"ND", text:"North Dakota" },
                    { value:"NE", text:"Nebraska" },
                    { value:"NH", text:"New Hampshire" },
                    { value:"NJ", text:"New Jersey" },
                    { value:"NM", text:"New Mexico" },
                    { value:"NV", text:"Nevada" },
                    { value:"NY", text:"New York" },
                    { value:"OH", text:"Ohio" },
                    { value:"OK", text:"Oklahoma" },
                    { value:"OR", text:"Oregon" },
                    { value:"PA", text:"Pennsylvania" },
                    { value:"RI", text:"Rhode Island" },
                    { value:"SC", text:"South Carolina" },
                    { value:"SD", text:"South Dakota" },
                    { value:"TN", text:"Tennessee" },
                    { value:"TX", text:"Texas" },
                    { value:"UT", text:"Utah" },
                    { value:"VA", text:"Virginia" },
                    { value:"VI", text:"Virgin Islands"},
                    { value:"VT", text:"Vermont" },
                    { value:"WA", text:"Washington" },
                    { value:"WI", text:"Wisconsin" },
                    { value:"WV", text:"West Virginia" },
                    { value:"WY", text:"Wyoming" },
                ],

                countryOptions: [
                    { value:"AFGHANISTAN", text:"Afghanistan" },
                    { value:"ALBANIA", text:"Albania" },
                    { value:"ALGERIA", text:"Algeria" },
                    { value:"ANDORRA", text:"Andorra" },
                    { value:"ANGOLA", text:"Angola" },
                    { value:"ANGUILLA", text:"Anguilla" },
                    { value:"ANTIGUA/BARBUDA", text:"Antigua and Barbuda" },
                    { value:"ARGENTINA", text:"Argentina" },
                    { value:"ARMENIA", text:"Armenia" },
                    { value:"ARUBA", text:"Aruba" },
                    { value:"AUSTRALIA", text:"Australia" },
                    { value:"AUSTRIA", text:"Austria" },
                    { value:"AZERBAIJAN", text:"Azerbaijan" },
                    { value:"BAHAMAS", text:"Bahamas, The" },
                    { value:"BAHRAIN", text:"Bahrain" },
                    { value:"BANGLADESH", text:"Bangladesh" },
                    { value:"BARBADOS", text:"Barbados" },
                    { value:"BELARUS", text:"Belarus" },
                    { value:"BELGIUM", text:"Belgium" },
                    { value:"BELIZE", text:"Belize" },
                    { value:"BENIN", text:"Benin" },
                    { value:"BERMUDA", text:"Bermuda" },
                    { value:"BHUTAN", text:"Bhutan" },
                    { value:"BOLIVIA", text:"Bolivia" },
                    { value:"BOSNIA/HERCEGOVINA", text:"Bosnia and Hercegovina" },
                    { value:"BOTSWANA", text:"Botswana" },
                    { value:"BRAZIL", text:"Brazil" },
                    { value:"BRUNEI", text:"Brunei" },
                    { value:"BULGARIA", text:"Bulgaria" },
                    { value:"BURKINA FASO", text:"Burkina Faso" },
                    { value:"BURMA", text:"Burma (Myanmar)" },
                    { value:"BURUNDI", text:"Burundi" },
                    { value:"CAMBODIA", text:"Cambodia" },
                    { value:"CAMEROON", text:"Cameroon" },
                    { value:"CANADA", text:"Canada" },
                    { value:"CAPE VERDE", text:"Cape Verde" },
                    { value:"CAYMAN ISLANDS", text:"Cayman Islands" },
                    { value:"CENTRAL AFRICAN REPUBLIC", text:"Central African Republic" },
                    { value:"CHAD", text:"Chad" },
                    { value:"CHILE", text:"Chile" },
                    { value:"CHINA", text:"China" },
                    { value:"COLOMBIA", text:"Colombia" },
                    { value:"COMOROS", text:"Comoros" },
                    { value:"CONGO, REPUBLIC", text:"Congo, Republic of" },
                    { value:"CONGO, DEMOCRATIC REPUBLIC", text:"Congo, Democratic Republic of" },
                    { value:"COSTA RICA", text:"Costa Rica" },
                    { value:"CROATIA", text:"Croatia" },
                    { value:"CUBA", text:"Cuba" },
                    { value:"CYPRUS", text:"Cyprus" },
                    { value:"CZECH REPUBLIC", text:"Czech Republic" },
                    { value:"DJIBOUTI", text:"Djibouti" },
                    { value:"DOMINICA", text:"Dominica" },
                    { value:"DOMINICAN REPUBLIC", text:"Dominican Republic" },
                    { value:"ECUADOR", text:"Ecuador" },
                    { value:"EGYPT", text:"Egypt" },
                    { value:"EL SALVADOR", text:"El Salvador" },
                    { value:"EQUATORIAL GUINEA", text:"Equatorial Guinea" },
                    { value:"ERITREA", text:"Eritrea" },
                    { value:"ESTONIA", text:"Estonia" },
                    { value:"ETHIOPIA", text:"Ethiopia" },
                    { value:"FIJI", text:"Fiji" },
                    { value:"FINLAND", text:"Finland" },
                    { value:"FRANCE", text:"France" },
                    { value:"FRENCH GUIANA", text:"French Guiana" },
                    { value:"GABON", text:"Gabon" },
                    { value:"GAMBIA", text:"Gambia, The" },
                    { value:"GAZA STRIP", text:"Gaza Strip" },
                    { value:"GEORGIA", text:"Georgia" },
                    { value:"GERMANY", text:"Germany" },
                    { value:"GHANA", text:"Ghana" },
                    { value:"GREECE", text:"Greece" },
                    { value:"GRENADA", text:"Grenada" },
                    { value:"GUADELOUPE", text:"Guadeloupe" },
                    { value:"GUATEMALA", text:"Guatemala" },
                    { value:"GUINEA", text:"Guinea" },
                    { value:"GUINEA-BISSAU", text:"Guinea-Bissau" },
                    { value:"GUYANA", text:"Guyana" },
                    { value:"HAITI", text:"Haiti" },
                    { value:"HONDURAS", text:"Honduras" },
                    { value:"HONG KONG", text:"Hong Kong" },
                    { value:"HUNGARY", text:"Hungary" },
                    { value:"ICELAND", text:"Iceland" },
                    { value:"INDIA", text:"India" },
                    { value:"INDONESIA", text:"Indonesia" },
                    { value:"IRAN", text:"Iran" },
                    { value:"IRAQ", text:"Iraq" },
                    { value:"IRELAND", text:"Ireland" },
                    { value:"ISRAEL", text:"Israel" },
                    { value:"ITALY", text:"Italy" },
                    { value:"IVORY COAST", text:"Ivory Coast" },
                    { value:"JAMAICA", text:"Jamaica" },
                    { value:"JAPAN", text:"Japan" },
                    { value:"JORDAN", text:"Jordan" },
                    { value:"KAZAKHSTAN", text:"Kazakhstan" },
                    { value:"KENYA", text:"Kenya" },
                    { value:"N KOREA", text:"Korea, North (Democratic Peoples Rep)" },
                    { value:"S KOREA", text:"Korea, South (Republic of)" },
                    { value:"KOSOVO", text:"Kosovo" },
                    { value:"KUWAIT", text:"Kuwait" },
                    { value:"KYRGYZSTAN", text:"Kyrgyzstan" },
                    { value:"LAOS", text:"Laos" },
                    { value:"LATVIA", text:"Latvia" },
                    { value:"LEBANON", text:"Lebanon" },
                    { value:"LESOTHO", text:"Lesotho" },
                    { value:"LIBERIA", text:"Liberia" },
                    { value:"LIBYA", text:"Libya" },
                    { value:"LIECHTENSTEIN", text:"Liechtenstein" },
                    { value:"LITHUANIA", text:"Lithuania" },
                    { value:"LUXEMBOURG", text:"Luxembourg" },
                    { value:"MACAU", text:"Macau" },
                    { value:"MACEDONIA", text:"Macedonia" },
                    { value:"MADAGASCAR", text:"Madagascar" },
                    { value:"MALAWI", text:"Malawi" },
                    { value:"MALAYSIA", text:"Malaysia" },
                    { value:"MALDIVES", text:"Maldives" },
                    { value:"MALI", text:"Mali" },
                    { value:"MALTA", text:"Malta" },
                    { value:"MARTINIQUE", text:"Martinique" },
                    { value:"MAURITANIA", text:"Mauritania" },
                    { value:"MAURITIUS", text:"Mauritius" },
                    { value:"MEXICO", text:"Mexico" },
                    { value:"MICRONESIA", text:"Micronesia, Federated States of" },
                    { value:"MOLDOVA", text:"Moldova" },
                    { value:"MONACO", text:"Monaco" },
                    { value:"MONGOLIA", text:"Mongolia" },
                    { value:"MONTENEGRO", text:"Montenegro" },
                    { value:"MOROCCO", text:"Morocco" },
                    { value:"MOZAMBIQUE", text:"Mozambique" },
                    { value:"NAMIBIA", text:"Namibia" },
                    { value:"NAURU", text:"Nauru" },
                    { value:"NEPAL", text:"Nepal" },
                    { value:"NETHERLANDS", text:"Netherlands" },
                    { value:"NEW CALEDONIA", text:"New Caledonia" },
                    { value:"NEW ZEALAND", text:"New Zealand" },
                    { value:"NICARAGUA", text:"Nicaragua" },
                    { value:"NIGER", text:"Niger" },
                    { value:"NIGERIA", text:"Nigeria" },
                    { value:"NORWAY", text:"Norway" },
                    { value:"OMAN", text:"Oman" },
                    { value:"PAKISTAN", text:"Pakistan" },
                    { value:"PANAMA", text:"Panama" },
                    { value:"PAPUA NEW GUINEA", text:"Papua New Guinea" },
                    { value:"PARAGUAY", text:"Paraguay" },
                    { value:"PERU", text:"Peru" },
                    { value:"PHILIPPINES", text:"Philippines" },
                    { value:"POLAND", text:"Poland" },
                    { value:"PORTUGAL", text:"Portugal" },
                    { value:"QATAR", text:"Qatar" },
                    { value:"ROMANIA", text:"Romania" },
                    { value:"RUSSIA", text:"Russia" },
                    { value:"RWANDA", text:"Rwanda" },
                    { value:"ST KITTS/NEVIS", text:"Saint Kitts and Nevis" },
                    { value:"SAINT LUCIA", text:"Saint Lucia" },
                    { value:"ST VINCENT/GRENADINES", text:"Saint Vincent and The Grenadines" },
                    { value:"SAMOA", text:"Samoa" },
                    { value:"SAO TOME AND PRINCIPE", text:"Sao Tome and Principe" },
                    { value:"SAUDI ARABIA", text:"Saudi Arabia" },
                    { value:"SENEGAL", text:"Senegal" },
                    { value:"SERBIA", text:"Serbia" },
                    { value:"SEYCHELLES", text:"Seychelles" },
                    { value:"SIERRA LEONE", text:"Sierra Leone" },
                    { value:"SINGAPORE", text:"Singapore" },
                    { value:"SLOVAKIA", text:"Slovakia" },
                    { value:"SLOVENIA", text:"Slovenia" },
                    { value:"SOMALIA", text:"Somalia" },
                    { value:"SOUTH AFRICA", text:"South Africa" },
                    { value:"S SUDAN", text:"South Sudan, Republic of" },
                    { value:"SPAIN", text:"Spain" },
                    { value:"SRI LANKA", text:"Sri Lanka" },
                    { value:"SUDAN", text:"Sudan" },
                    { value:"SURINAME", text:"Suriname" },
                    { value:"SWAZILAND", text:"Swaziland" },
                    { value:"SWEDEN", text:"Sweden" },
                    { value:"SWITZERLAND", text:"Switzerland" },
                    { value:"SYRIA", text:"Syria" },
                    { value:"TAIWAN", text:"Taiwan" },
                    { value:"TAJIKISTAN", text:"Tajikistan" },
                    { value:"TANZANIA", text:"Tanzania, United Republic of" },
                    { value:"THAILAND", text:"Thailand" },
                    { value:"TIBET", text:"Tibet" },
                    { value:"TIMOR-LESTE", text:"Timor-Leste" },
                    { value:"TOGO", text:"Togo" },
                    { value:"TRINIDAD/TOBAGO", text:"Trinidad and Tobago" },
                    { value:"TUNISIA", text:"Tunisia" },
                    { value:"TURKEY", text:"Turkey" },
                    { value:"TURKMENISTAN", text:"Turkmenistan" },
                    { value:"TURKS/CAICOS ISLANDS", text:"Turks and Caicos Islands" },
                    { value:"UGANDA", text:"Uganda" },
                    { value:"UKRAINE", text:"Ukraine" },
                    { value:"UAE", text:"United Arab Emirates" },
                    { value:"UK", text:"United Kingdom" },
                    { value:"URUGUAY", text:"Uruguay" },
                    { value:"UZBEKISTAN", text:"Uzbekistan" },
                    { value:"VATICAN CITY", text:"Vatican City" },
                    { value:"VENEZUELA", text:"Venezuela" },
                    { value:"VIETNAM", text:"Vietnam" },
                    { value:"W BANK", text:"West Bank" },
                    { value:"W SAHARA", text:"Western Sahara" },
                    { value:"YEMEN", text:"Yemen" },
                    { value:"ZAMBIA", text:"Zambia" },
                ]
            }
        }
    }
}